import React from 'react';
import SearchBar from './SearchBar';

const About = () => (
	<main>
	<SearchBar />
		<div className="about about-wrapper">
			<h2>Welcome to React Movie App Project</h2>
			<section className="about about-project">
				<h3>About the Project</h3>
				<p>React Movie App is a Movie Database Project listing the movies based on popularity, rating and release date. <br/>Browse for your favourite movie, and add it to the Favourite List, and save it for the Watch Later list.</p>
				<p><span>&#9734; </span>This website uses the TMDb API for educational purpose.</p>
			</section>
			<section className="about">
			<h3>Development Tools</h3>
				<div className="HTML">HTML</div>
				<div className="SASS">SASS</div>
				<div className="JavaScript">JavaScript</div>
				<div className="GIT">GIT</div>
				<div className="NPM">NPM</div>
			</section>
		</div>
	</main>
);

export default About;